// commonFile.js
import { toast } from "react-toastify";
import axios from "axios";
import config from "../common/mis";
import { styled } from "@mui/material";
import * as XLSX from "xlsx";

// import { Redirect } from "../../api/index";
export async function secureAjaxCallWithCallback(
  serviceUrl,
  inputData,
  successFunction,
  failFunction
) {
  try {
    const response = await fetch(serviceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",

      },
      credentials: "include",
      body: JSON.stringify(inputData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    successFunction(data);
  } catch (error) {
    failFunction(error);
    misAlert("error", `An error has occurred: ${error.message}`);
  }
}

export async function parseJson(data) {
  return data ? (typeof data === "object" ? data : JSON.parse(data)) : data;
}
// const postData = async (url, requestData = {}) => {
// export async function postData(ApiUrl, inputData) {
//   try {
//     const response = await axios.post(ApiUrl, inputData, {
//       headers: {
//         "Content-Type": "application/json",
//         "cyient-access-token": sessionStorage.getItem("jwtToken"),
//         "CSRF-Token": sessionStorage.getItem("csrfToken"),
//       },
//     });

//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// }
export async function postData(ApiUrl, inputData) {
  try {
    const response = await axios.post(ApiUrl, inputData, {
      headers: {
        "Content-Type": "application/json",
        // "Accept-Encoding": "identity",
        "cyient-access-token": sessionStorage.getItem("jwtToken"),
        "CSRF-Token": sessionStorage.getItem("csrfToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}


// postData1 function in common.js
export async function postData1(url = "", data = {}) {
  const token = sessionStorage.getItem("jwtToken"); // Retrieve token from sessionStorage

  if (!token) {
    throw new Error("No token found in session storage");
  }

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json", // Content type
      "cyient-access-token": token, // Add the token to the header
    },
    body: JSON.stringify(data), // Send the data in the body
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return response.json(); // Return the parsed JSON response
}

export async function misAlert(type, message) {
  let toastType;
  switch (type.toLowerCase()) {
    case "info":
      toastType = "info";
      break;
    case "success":
      toastType = "success";
      break;
    case "warning":
      toastType = "warning";
      break;
    case "error":
      toastType = "error";
      break;
    case "information":
      toastType = "info"; // Changed to 'info' for clarity
      break;
    default:
      toastType = "default"; // 'default' is not a valid type, you might want to handle this differently
  }

  toast(message, {
    type: toastType,
    theme: "colored",
  });
}
export const populateDataInList = async (serviceUrl, inputdata) => {
  try {
    const response = await fetch(serviceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "cyient-access-token": sessionStorage.getItem("jwtToken"),
        "CSRF-Token": sessionStorage.getItem("csrfToken"),
      },
      credentials: "include",
      body: JSON.stringify(inputdata),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const generateColumnsWithAction = (columnsConfig) => {
  const columns = columnsConfig.split(",").map((col) => ({
    Header: col.toLowerCase(),
    accessor: col.toLowerCase(),
  }));
  columns.push({
    Header: "Action",
    accessor: "action",
  });
  return columns;
};

export const generateColumns = (columnsConfig) =>
  columnsConfig.split(",").map((col) => ({
    Header: col.toLowerCase(),
    accessor: col.toLowerCase(),
  }));

export const fetchFilterDrops = async (action, queryFields, setData) => {
  try {
    const response = await populateDataInList(config.ProcessQuery.url, {
      action: action,
      AndOr: "and",
      queryFields: queryFields,
    });

    setData(response || []);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};
export const fetchFilterDrops1 = async (inputdata, setData) => {
  try {
    const response = await populateDataInList(config.ProcessQuery.url, inputdata);
    setData(response || []);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};


// CardTitle Component
export const CardTitle = styled("div")(({ subtitle }) => ({
  fontSize: "1rem",
  fontWeight: "500",
  textTransform: "capitalize",
  marginBottom: !subtitle && "16px",
}));

// Container Component
export const Container = styled("div")(({ theme }) => ({
  margin: "30px",
  [theme.breakpoints.down("sm")]: { margin: "16px" },
  "& .breadcrumb": {
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: { marginBottom: "16px" },
  },
}));


// commonFile.js (or wherever the function is defined)
export const fetchTabledata = async (tableName, setData) => {
  try {
    const processesData = await postData(config.ProcessQueryCursor.url, {
      action: "gettabledata",
      "values[]": tableName,  // Use tableName as a dynamic prop
    });

    setData(
      Array.isArray(processesData?.data?.[1]) ? processesData.data[1] : []
    );
  } catch (error) {
    console.error("Error fetching processes:", error);
  }
};
export const fetchTabledataColum = async (tableName, Columnname, valu, setData) => {
  try {
    const processesData = await postData(config.ProcessQueryCursor.url, {
      action: "gettabledatawithcolum",
      "values[]": [tableName, Columnname, valu],
    });

    const result = Array.isArray(processesData?.data?.[1]) ? processesData.data[1] : [];

    // If setData is provided, use it. Otherwise, return the result
    if (typeof setData === 'function') {
      setData(result);
    } else {
      return result;
    }
  } catch (error) {
    console.error("Error fetching processes:", error);
    if (!setData) {
      return []; // Ensure return even if there's an error and no setData
    }
  }
};

export const fetchData = async (userid, columns, filtertext, tableName, orderbyColumn, setData) => {
  try {
    const requestData = {
      action: "getdatafordatatable",
      "values[]": [userid, columns, "", filtertext, tableName, "0", "200000000", orderbyColumn]
    };
    const response = await postData(config.ProcessDataTableQuery.url, requestData);
    const fetchedData = Array.isArray(response?.data?.[1]) ? response.data[1] : [];
    setData(fetchedData);
  } catch (error) {
    misAlert("error", "Error fetching data", error.message || error);
  }
};
// utils.js
export const refreshMVData = async () => {
  const inputdata = { action: "getrefeshmv", values: 'mvjobsdata' };
  try {
    await postData(config.ProcessQueryWitVals.url, inputdata);
    return true;
  } catch (error) {
    misAlert("error", "Error refreshing data");
    return false;
  }
};
export async function downloadExcelBatched(tablename,
  view,
  finalFilter = "",
  totalRowCount = 1000,
  chunkSize = 1000,
  sort
) {
  try {

    // ✅ 1. Get JWT token
    const jwtToken = sessionStorage.getItem("jwtToken");
    if (!jwtToken) {
      console.error("JWT token is missing! Cannot download Excel.");
      return;
    }

    // ✅ 2. Prepare filter
    const filterClause =
      finalFilter

    let allData = [];

    // ✅ 3. Fetch data in chunks
    for (let start = 0; start < totalRowCount; start += chunkSize) {
      const payload = {
        table: view,
        filter: filterClause,
        sort: sort,
        start: start,
        limit: Math.min(chunkSize, totalRowCount - start),

      };

      const response = await axios.post(
        config.ProcessDataTable.url, // replace with your config URL
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "cyient-access-token": jwtToken,
            "CSRF-Token": sessionStorage.getItem("csrfToken"),
            // "Accept-Encoding": "identity", // prevent decoding issues
          },
        }
      );
      const chunkData = response.data?.data;
      if (chunkData && Array.isArray(chunkData)) {
        allData = allData.concat(chunkData);
      }
    }
    if (!allData.length) {
      console.warn("No data returned for Excel download.");
      return;
    }
    // ✅ 4. Convert JSON → worksheet
    const worksheet = XLSX.utils.json_to_sheet(allData);
    // ✅ 5. Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    // ✅ 6. Trigger Excel download
    XLSX.writeFile(workbook, `${tablename}.xlsx`);
    console.log("Excel downloaded successfully!");
  } catch (error) {
    console.error("Excel generation failed:", error);
  }
}
